import React, { useState, useImperativeHandle, forwardRef } from "react";
import { Button, Text, Input, Checkbox, Icon } from "@virkesborsen/ui-component-library";

const BookingStep = forwardRef(({ onNext,formData }, ref) => {
    const [bookingReview, setBookingReview] = useState(formData?.bookingReview ||{})

     useImperativeHandle(ref, () => ({
            validateAndReturn() {
    
                if (Object.keys(bookingReview).length == 0) {    
                    return { errors: true };
                }
    
                return {
                    data: {
                        bookingReview:bookingReview,
                        step:"treeform_booking_review"
                    }
                };
            }
        }));
    return (
        <div className="h-full flex flex-col justify-center items-center">
            <div className="w-full md:w-[500px] px-10 grid grid-row gap-4">
                <Text variant="text-xl/leading-normal/normal" className="text-white">3. Vad kan vi hjälpa dig med? (välj ett eller flera alternativ)</Text>
                <div>
                    <Checkbox
                        name="Sälja virke & biobränsle"
                        onClick={(val) => {setBookingReview(prev=>({...prev,saljaVirke:val}))}}
                        checked={bookingReview?.saljaVirke}
                    >
                        <Text variant="text-sm/leading-normal/normal" className="text-white">Sälja virke & biobränsle</Text>
                    </Checkbox>
                </div>
                <div>
                    <Checkbox
                        name="Skogsbruksplan"
                        onClick={(val) => {setBookingReview(prev=>({...prev,skogsbruksplan:val}))}}
                        checked={bookingReview?.skogsbruksplan}
                    >
                        <Text variant="text-sm/leading-normal/normal" className="text-white">Skogsbruksplan</Text>
                    </Checkbox>
                </div>
                <div>
                    <Checkbox
                        name="Fastighetsvärdering"
                        onClick={(val) => {setBookingReview(prev=>({...prev,fastighetsvardering:val}))}}
                        checked={bookingReview?.fastighetsvardering}
                    >
                        <Text variant="text-sm/leading-normal/normal" className="text-white">Fastighetsvärdering</Text>
                    </Checkbox>
                </div>
                <div>
                    <Checkbox
                        name="Marknadsinformation"
                        onClick={(val) => {setBookingReview(prev=>({...prev,marknadsinformation:val}))}}
                        checked={bookingReview?.marknadsinformation}
                    >
                        <Text variant="text-sm/leading-normal/normal" className="text-white">Marknadsinformation</Text>
                    </Checkbox>
                </div>

                <div>
                    <Checkbox
                        name="Prisjämförelsen"
                        onClick={(val) => {setBookingReview(prev=>({...prev,prisjamforelsen:val}))}}
                        checked={bookingReview?.prisjamforelsen}
                    >
                        <Text variant="text-sm/leading-normal/normal" className="text-white">Prisjämförelsen</Text>
                    </Checkbox>
                </div>
                <div>
                    <Checkbox
                        name="Kolkrediter"
                        onClick={(val) => {setBookingReview(prev=>({...prev,kolkrediter:val}))}}
                        checked={bookingReview?.kolkrediter}
                    >
                        <Text variant="text-sm/leading-normal/normal" className="text-white">Kolkrediter</Text>
                    </Checkbox>
                </div>

                <div>
                    <Checkbox
                        name="Övrigt"
                        onClick={(val) => {setBookingReview(prev=>({...prev,ovrigt:val}))}}
                        checked={bookingReview?.ovrigt}
                    >
                        <Text variant="text-sm/leading-normal/normal" className="text-white">Övrigt</Text>
                    </Checkbox>
                </div>


            </div>
            <div className="fixed bottom-0 left-0 w-full sm:static sm:w-auto sm:h-auto sm:flex sm:justify-center sm:items-center mt-4">
                <div className="flex justify-center items-center py-4 px-2 sm:py-0">
                    <Button
                        tw
                        onClick={()=>{onNext({data:{
                            bookingReview:bookingReview,
                            step:"treeform_booking_review"
                        }})}}
                        variant="quaternary"
                        fullWidth
                        disabled={Object.keys(bookingReview).length > 0 ? false:true}
                    >
                        Nästa
                        <Icon
                            className="fill-charcoal-500"
                            name="ArrowRightSimple"
                            size="large"
                        />
                    </Button>
                </div>
            </div>
        </div>
    )
});

export default BookingStep;